module.exports = __webpack_public_path__ + "static/media/icon_comment_on.2d222455.svg";